import { AxiosRequestConfig } from 'axios'
import {
  MunMeh as Data,
  MunMehCollection as Collection,
} from '@/typings/api/MunMeh'
import {
  BaseApiParams,
} from '@/typings/common'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'

type CountResponse = {
  count: number;
}

export class LkRegMehApi extends BaseLkApiAuth<Data, Collection> {
  protected readonly endpoint = 'regmeh';

  public count<P extends BaseApiParams>(rawParams?: P, config?: AxiosRequestConfig) {
    const path = '/count'
    const [url, params] = this.getUrl(path, rawParams)
    return this.request<CountResponse>('GET', url, { params, ...config })
  }
}
